/**
 * cart-studentennachweis.js
 *
 * Blockiert "Zur Kasse" bis der Kunde bestätigt hat, den Studentenausweis
 * per E-Mail nachzureichen. Nutzt für das Speichern die zentrale
 * Funktion aus cart-line-sync.js, damit Werte anderer Features
 * (Prämie, Abo-Startmonat) in derselben Zeile erhalten bleiben.
 */

(function () {
  function alleStudentenBloecke() {
    return document.querySelectorAll('.cart-item__studentennachweis');
  }

  function gesamtstatusPruefen() {
    let irgendwasOffen = false;
    alleStudentenBloecke().forEach(function (container) {
      const checkbox = container.querySelector('.cart-item__studentennachweis-checkbox');
      if (!checkbox || !checkbox.checked) {
        irgendwasOffen = true;
      }
    });

    if (window.cartCheckoutGuard) {
      window.cartCheckoutGuard.setBlocker(
        'studentennachweis',
        irgendwasOffen,
        'Bitte bestätigen Sie die Zusendung Ihres Studentenausweises, um fortzufahren.'
      );
    }
  }

  function init() {
    alleStudentenBloecke().forEach(function (container) {
      const checkbox = container.querySelector('.cart-item__studentennachweis-checkbox');
      if (checkbox && checkbox.dataset.studentListenerGebunden !== 'true') {
        checkbox.dataset.studentListenerGebunden = 'true';
        checkbox.addEventListener('change', function (e) {
          e.stopPropagation();
          gesamtstatusPruefen();
          const zeile = container.closest('tr.cart-item');
          if (zeile) window.cartLineSync.aktualisieren(zeile);
        });
      }
    });
    gesamtstatusPruefen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Das Theme ersetzt bei Mengenänderungen (+/- bzw. Entfernen) den
  // Warenkorb-Bereich per Ajax und meldet das danach über 'cart-update'.
  // Die frisch gerenderten Elemente brauchen dann erneut ihre Listener
  // bzw. Dropdown-Optionen. Event-basiert statt MutationObserver, damit
  // keine Endlosschleife durch eigene DOM-Änderungen entstehen kann.
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () {
      init();
    });
  }
})();
